import { QueryClient, type QueryClientConfig } from "@tanstack/react-query";
import { merge } from "lodash";

export const makeQueryClient = (config?: QueryClientConfig) =>
    new QueryClient(
        merge(
            {},
            {
                defaultOptions: {
                    queries: {
                        staleTime: Infinity,
                        refetchOnWindowFocus: false,
                        refetchOnMount: false,
                        refetchOnReconnect: false,
                        retry: false,
                    },
                },
            },
            config,
        ),
    );
